import React from 'react';
import './App.css';
import BookingForm from './components/BookingForm/BookingForm';

function App() {
  // Corporation ID from environment variables
  const corporationId = process.env.REACT_APP_CORPORATION_ID || '';

  return (
    <div className="App">
      <BookingForm corporationId={corporationId} />
    </div>
  );
}

export default App;

